import MuiTypography from '@mui/material/Typography';
import { TypographyProps as MuiTypographyProps } from '@mui/material/Typography';

export type { TypographyProps as MuiTypographyProps };

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface TypographyProps extends MuiTypographyProps {}

export function Typography<C extends React.ElementType>(
  props: MuiTypographyProps<C, { component?: C }> & TypographyProps
) {
  const { color, ...extraProps } = props;

  const regularColors = {
    primary: 'primary.text',
    secondary: 'secondary.text',
    warning: 'warning.text',
    error: 'error.text',
    info: 'info.text',
    success: 'success.text',
    textDisabled: 'text.disabled',
  };

  const specialColor = color && regularColors[color];

  return <MuiTypography color={specialColor || color} {...extraProps} />;
}
